import { Divider, Virtualizer } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { notEmpty } from '@mews-commander/utils';
import { PaymentItem } from './PaymentItem';

interface PaymentProps {
    paymentIds: Array<string>;
}

export const PaymentList: React.FC<PaymentProps> = ({ paymentIds }) => {
    const divider = notEmpty(paymentIds) ? (
        <Divider>
            <LocalizedText textKey={TextKey.PaymentPlural} />
        </Divider>
    ) : null;

    const paymentList =
        paymentIds.length < 10 ? (
            <div>
                {paymentIds.map((paymentId) => (
                    <PaymentItem key={paymentId} paymentId={paymentId} />
                ))}
            </div>
        ) : (
            <div>
                <Virtualizer
                    height={400}
                    estimatedSize={40}
                    overscan={20}
                    items={paymentIds.map((paymentId) => (
                        <PaymentItem key={paymentId} paymentId={paymentId} />
                    ))}
                />
            </div>
        );

    return (
        <div>
            {divider}
            {paymentList}
        </div>
    );
};
